import { HeaderMenu } from '@/components/header-menu';
import styles from './messages.module.scss';
import { useGetSettings } from '@/hooks/use-get-settings';
import { NewCouples } from '@/components/new-couples';
import { MessagesList } from '@/components/messages-list';
import { useEffect, useMemo, useState } from 'react';
import { Chat, ChatsListResponse, Couples } from '@/types/chat';
import { routesApp } from '@/constans/routes';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/store/useAuth';
import { PaginationDto } from '@/types/message';
import { profilesApi } from '@/api';
import WebApp from '@twa-dev/sdk';
import { jwtService } from '@/services/jwt.service';
import { useActionCableCreate } from '@/hooks/use-action-cable';
import { SocketPayload } from '@/types/socket-payload';
import { PROFILE_CHANNEL_RECEIVED } from '@/utils/events';

export function Messages() {
    const userData = useAuth((state) => state.getUser());
    const navigate = useNavigate();
    const [pagination, setPagination] = useState<PaginationDto | null>(null);
    const [chatList, setChatList] = useState<ChatsListResponse | null>(null);
    const [isLoadingChats, setLoadingChats] = useState<boolean>(false);
    const [isLoadingCouples, setIsLoadingCouples] = useState<boolean>(false);
    const [isLoadingChatsPagination, setLoadingChatsPagination] = useState<boolean>(false);
    const [isErrorChats, setErrorChats] = useState<Error | null>(null);
    const [allChats, setAllChats] = useState<Chat[] | null>(null);
    const [allCouple, setAllCouples] = useState<Couples[] | null>(null)
    useGetSettings();
    
    const isLoading = isLoadingChats;
    const isEmptyMessage =
        allChats !== null &&
        allChats?.length === 0

    const [isModerationReviewRequested, setModerationReviewRequested] = useState(false)

    useEffect(() => {
        setModerationReviewRequested(
            Boolean(
                localStorage
                    .getItem('IS_MODERATION_REVIEW_REQUESTED')
            )
        )
    }, [])

    const isNotModerated =
        userData
            ?.moderation_status
            === 'change_required'

    const isModerationPending =
        userData
            ?.violations_resolved

    useEffect(() => {
        if (isErrorChats) {
            const axiosError = isErrorChats as any;
            if (
                axiosError.response?.status === 403 &&
                axiosError.response?.data?.is_banned
            ) navigate(routesApp.banned);
        }
    }, [isErrorChats]);

    useEffect(() => {
        (async () => {
            console.log('use effect')
            setLoadingChats(true)
            setIsLoadingCouples(true)
            try {
                // нужно переделать логику запроса под @tanstack/react-query
                let data = await profilesApi.getChats(1);

                if (data.data.data) {
                    setAllChats(data.data.data);

                    if (data.data.pagination) {
                        setPagination(data.data.pagination);
                        console.log('new pagination');
                    }
                }

                let dataCouples = await profilesApi.getCouple();

                if (dataCouples) {
                    setAllCouples(dataCouples.data)
                }
            } catch (error) {
                console.error('Error loading chats:', error);
                setErrorChats(error as Error)
            } finally {
                setLoadingChats(false)
                setIsLoadingCouples(false)
            }
        })()
        return () => {
            setAllChats(null);
            setChatList(null);
            setErrorChats(null);
            setLoadingChats(false);
            setPagination(null);
        };
    }, [userData?.active]);

    const getSortedChatList = useMemo(() => {
        const chats = allChats;

        if (userData && !userData?.active) return []

        if (!chats) return null;

        return allChats

    }, [allChats, userData?.active]);

    const loadMoreChats = async () => {
        console.log('loadMoreChats')
        try {
            if (
                pagination &&
                pagination.next &&
                !isLoading &&
                !isLoadingChatsPagination
            ) {
                setLoadingChatsPagination(true)
                // нужно переделать логику запроса под @tanstack/react-query
                let data = await profilesApi.getChats(pagination.next);

                if (data.data.data) {
                    setAllChats((prev) => {
                        const newChats = data.data.data.filter(
                            newChat => !prev?.some(
                                existingChat => existingChat.chat_id === newChat.chat_id
                            ),
                        );
                        return [...prev ?? [], ...newChats];
                    });

                    setPagination(data.data.pagination);
                    console.log('new pagination');
                }
            }
        } catch (error) {
            console.error('Error loading more chats:', error);
            setErrorChats(error as Error)
        } finally {
            setLoadingChatsPagination(false)
        }
    };

    const onProfileChannelReceived = (data: CustomEventInit) => {
        const payload = data.detail
        switch (payload.type) {
            case 'message_created':
                setAllChats(
                    prevChats => {
                        // Проверяем, есть ли уже такой чат
                        const chatExists = prevChats?.some(
                            chat => {
                                console.log('prevChats', prevChats);
                                return chat.chat_id === payload.data.chat_id;
                            }
                        );
                        const newChats = chatExists
                            ? (prevChats ?? []).map(
                                chat =>
                                        chat.chat_id === payload.data.chat_id ?
                                            payload.data
                                        : chat
                            ) // Если сообщение существует - обновляем его
                            : [...prevChats ?? [], payload.data]; // Если чат новый - добавляем в конец
                        return newChats;
                    }
                );
                break;
            case 'chat_created':
                setAllChats(
                    prevChats => {
                        // Проверяем, есть ли уже такой чат
                        const chatExists = prevChats?.some(
                            chat => {
                                console.log('prevChats', prevChats);
                                return chat.chat_id === payload.data.chat_id;
                            }
                        );
                        const newChats = chatExists
                            ? (prevChats ?? []).map(
                                chat =>
                                        chat.chat_id === payload.data.chat_id ?
                                            payload.data
                                        : chat
                            ) // Если сообщение существует - обновляем его
                            : [...prevChats ?? [], payload.data]; // Если чат новый - добавляем в конец
                        return newChats;
                    }
                );
                break;
        }
    }
    
    useEffect(() => {
        window.addEventListener(PROFILE_CHANNEL_RECEIVED, onProfileChannelReceived)
        return () => {
            window.removeEventListener(PROFILE_CHANNEL_RECEIVED, onProfileChannelReceived)
        };
    }, []);

    return (
        <div className={styles.messages}>
            <HeaderMenu title="Сообщения" isFixed={isEmptyMessage} />
            <NewCouples
                matches={allCouple}
                isLoading={isLoadingCouples} />
            <MessagesList
                isLoading={isLoading}
                chatList={getSortedChatList}
                isEmptyMessage={isEmptyMessage}
                isNotModerated={isNotModerated}
                isModerationPending={isModerationPending}
                isFillYourDataFinished={userData?.state === 'half_done'}
                pagination={pagination}
                loadMoreChats={loadMoreChats} />
        </div>
    );
}
